import React from "react";
import styles from "./styles.module.css";
import {
  HSTicket,
  HubspotTicketStatus,
} from "@robotical/analytics-gatherer/dist/types";
import { ZohoTicket } from "@robotical/appv2-warranty-service-lib/dist/types/serviceProgramDatabase";
import { Badge, Button, formatDate } from "../../UI";
interface TicketItemProps {
  ticket: HSTicket | ZohoTicket;
  onUpdateStatus: (status: HubspotTicketStatus) => void;
  serialNumber?: string;
  robotName?: string;
  pending?: boolean;
}
const TicketItem: React.FC<TicketItemProps> = ({
  ticket,
  onUpdateStatus,
  serialNumber,
  robotName,
  pending = false,
}) => {
  const closed = ticket.status === "Closed";
  const ticketId =
    "hubspotTicketId" in ticket ? ticket.hubspotTicketId : ticket.id;
  return (
    <article className={styles.ticketItem} aria-label={`Ticket ${ticketId}`}>
      <div className={styles.issue}>
        <h3>Automatically detected issue</h3>
        <p>Ticket #{ticketId}</p>
      </div>
      <div className={styles.robot}>
        <span>{robotName || "Marty"}</span>
        <p>{serialNumber || ticket.serialNumber}</p>
      </div>
      <time className={styles.date} dateTime={ticket.date}>
        {formatDate(ticket.date, true)}
      </time>
      <div className={styles.status}>
        <Badge status={closed ? "closed" : "open"}>{ticket.status}</Badge>
      </div>
      <Button
        className={styles.action}
        disabled={pending}
        aria-busy={pending}
        onClick={() =>
          onUpdateStatus(
            closed ? HubspotTicketStatus.OPEN : HubspotTicketStatus.CLOSED,
          )
        }
      >
        {pending ? "Updating…" : closed ? "Reopen ticket" : "Close ticket"}
      </Button>
    </article>
  );
};
export default TicketItem;
